export async function apiJson(response: Response): Promise<any> {
  const text = await response.text();
  try {
    return JSON.parse(text);
  } catch {
    const messages: Record<number, string> = {
      400: "Revise os dados informados e tente novamente.",
      401: "Usuário ou senha inválidos, ou sua sessão expirou.",
      403: "Você não possui permissão para esta operação.",
      404: "O registro solicitado não foi encontrado.",
      500: "O servidor não conseguiu concluir a operação.",
    };
    return {error: messages[response.status] || "Não foi possível concluir a operação."};
  }
}
